import {
  collection,
  doc,
  getDoc,
  writeBatch,
  deleteDoc,
  setDoc,
  addDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase";
import { normalizeCode } from "./ids";
import { tt } from "../i18n";

export const ONLINE_WINDOW_MS = 150_000;

export const isOnline = (profile) => {
  const t = profile?.lastSeen?.toMillis?.();
  return !!t && Date.now() - t < ONLINE_WINDOW_MS;
};

export async function findByFriendCode(raw) {
  const code = normalizeCode(raw);
  if (!code) return null;
  const snap = await getDoc(doc(db, "friendCodes", code));
  if (!snap.exists()) return null;
  const uid = snap.data().uid;
  const profile = await getDoc(doc(db, "users", uid));
  return profile.exists() ? { uid, ...profile.data() } : null;
}

export async function acceptRequest(me, fromUid) {
  const batch = writeBatch(db);
  batch.set(doc(db, "users", me, "friends", fromUid), { since: serverTimestamp() });
  batch.set(doc(db, "users", fromUid, "friends", me), { since: serverTimestamp() });
  batch.delete(doc(db, "users", me, "requests", fromUid));
  await batch.commit();
}

// Returns "sent", "accepted" (they'd already asked us) or "already".
export async function sendFriendRequest(meProfile, targetUid) {
  const me = meProfile.uid;
  if (targetUid === me) throw new Error(tt("That's your own code, silly!"));
  const [alreadyFriends, theyAsked] = await Promise.all([
    getDoc(doc(db, "users", me, "friends", targetUid)),
    getDoc(doc(db, "users", me, "requests", targetUid)),
  ]);
  if (alreadyFriends.exists()) return "already";
  if (theyAsked.exists()) {
    await acceptRequest(me, targetUid);
    return "accepted";
  }
  await setDoc(doc(db, "users", targetUid, "requests", me), {
    fromName: meProfile.displayName,
    fromCode: meProfile.friendCode,
    fromAvatar: meProfile.avatar,
    createdAt: serverTimestamp(),
  });
  return "sent";
}

export const declineRequest = (me, fromUid) => deleteDoc(doc(db, "users", me, "requests", fromUid));

export async function removeFriend(me, friendUid) {
  const batch = writeBatch(db);
  batch.delete(doc(db, "users", me, "friends", friendUid));
  batch.delete(doc(db, "users", friendUid, "friends", me));
  await batch.commit();
}

export const sendInvite = (meProfile, friendUid, roomCode, game) =>
  addDoc(collection(db, "users", friendUid, "invites"), {
    fromUid: meProfile.uid,
    fromName: meProfile.displayName,
    fromAvatar: meProfile.avatar,
    roomCode,
    game,
    createdAt: serverTimestamp(),
  });

export const dismissInvite = (me, inviteId) => deleteDoc(doc(db, "users", me, "invites", inviteId));
